const ROUTES = {
  ROOT: "/journeys/:brandId?",
  WORKFLOW: "/workflow/:brandId/:automationId",
  TEMPLATES: "/Template/:TemplateType/:brandId",
  CREATEAUTOMATION: "/Automations/:brandId?",
  EDITAUTOMATION: "/Automations/:brandId/:automationId",
  CREATETOKEN: "/CreateToken/:brandId",
};

export default ROUTES;
